<div class="login-container container-fluid d-flex pt-5">
  <div class="container align-self-center">
    <div class="row">
      <div class="col-md-14 col-xxl-16 order-2 order-md-1">
        <h1>Welcome to The FX Clearing House</h1>
        <p class="text-justify">
          Aliquam sollicitudin eros lobortis purus mollis interdum et nec elit.
          Ut et posuere lorem. Vivamus vitae felis lectus. Nullam consequat
          turpis eu leo interdum bibendum. Phasellus justo massa, ultrices at
          viverra tincidunt, volutpat a dui. Vestibulum egestas at nulla eu
          placerat. Donec ipsum urna, scelerisque sit amet varius vel, dictum
          sed nulla. Suspendisse accumsan a quam a varius. Etiam neque massa,
          lobortis vel tortor sed, dignissim rhoncus massa. Etiam cursus dapibus
          ante, eu venenatis purus eleifend ac. Sed ornare turpis et eros
          aliquet elementum. Cras a condimentum metus. Nulla volutpat, lectus id
          suscipit pulvinar, lorem nisl ultricies ex, nec dictum ante erat sed
          leo. Vivamus ullamcorper ante augue, mollis dignissim ante vehicula
          eget. Sed nec tempor sem, quis volutpat eros.
        </p>
      </div>
      <div class="col-md-10 col-xxl-8 order-1 order-md-2">
        <div class="card mb-5 mb-md-0">
          <div class="card-body">
            <h4
              class="card-title text-center text-uppercase"
              *ngIf="
                event === loginEvent.FORGOT_PASSWORD_SUBMIT ||
                event === loginEvent.FORGOT_PASSWORD
              "
            >
              Forgot Password
            </h4>

            <h4
              class="card-title text-center text-uppercase"
              *ngIf="
                event === loginEvent.FORGOT_PASSWORD_SUBMIT ||
                event !== loginEvent.FORGOT_PASSWORD
              "
            >
              Please sign in
            </h4>

            <form [formGroup]="form" autocomplete="off">
              <div class="form-floating mb-3">
                <input
                  type="text"
                  required
                  formControlName="username"
                  class="form-control"
                  id="floatingUsername"
                  placeholder="Username"
                  autocomplete="off"
                  autocapitalize="none"
                />
                <label for="floatingUsername">Username</label>
                <span
                  class="form-text"
                  *ngIf="
                    event === loginEvent.FORGOT_PASSWORD_SUBMIT ||
                    event === loginEvent.FORGOT_PASSWORD
                  "
                  >Enter your username and click "Submit".</span
                >
              </div>
              <input
                type="hidden"
                name="${_csrf.parameterName}"
                value="${_csrf.token}"
              />
              <div
                class="form-floating mb-3"
                *ngIf="event === loginEvent.FORGOT_PASSWORD_SUBMIT"
              >
                <input
                  type="text"
                  required
                  formControlName="code"
                  class="form-control"
                  id="cde"
                  placeholder="Code"
                  autocomplete="off"
                  autocapitalize="none"
                />
                <label for="floatingUsername">Code</label>
              </div>
              <div
                class="form-floating mb-3"
                *ngIf="
                  event === loginEvent.NEW_PASSWORD_REQUIRED ||
                  event === loginEvent.LOGIN ||
                  event === loginEvent.FORGOT_PASSWORD_SUBMIT
                "
              >
                <input
                  type="password"
                  required
                  class="form-control"
                  id="floatingPassword"
                  placeholder="Password"
                  formControlName="password"
                />
                <label for="floatingPassword">Password</label>
              </div>
              <div
                class="form-floating mb-3"
                *ngIf="event === loginEvent.NEW_PASSWORD_REQUIRED"
              >
                <input
                  type="password"
                  required
                  class="form-control"
                  id="floatingNewPasswordRequired"
                  placeholder="New password"
                  formControlName="newPassword"
                />
                <label for="floatingNewPasswordRequired">New password</label>
              </div>
              <div
                class="form-floating mb-3"
                *ngIf="event === loginEvent.NEW_PASSWORD_REQUIRED"
              >
                <input
                  type="password"
                  required
                  class="form-control"
                  id="floatingNewPasswordRequiredAgain"
                  placeholder="New password again"
                  formControlName="newPasswordAgain"
                />
                <label for="floatingNewPasswordRequiredAgain"
                  >New password again</label
                >
              </div>

              <div class="col-24">
                <button
                  id="signInButton"
                  [disabled]="isLoginInProgress || form.invalid"
                  *ngIf="
                    event !== loginEvent.FORGOT_PASSWORD &&
                    event !== loginEvent.FORGOT_PASSWORD_SUBMIT
                  "
                  (click)="jLogin()"
                  class="w-50 btn btn-success text-uppercase"
                >
                  <i class="fa fa-lg fa-sign-in"></i> Sign in
                </button>
                <button
                  class="w-50 btn btn-link"
                  (click)="backToLogin()"
                  *ngIf="
                    event === loginEvent.FORGOT_PASSWORD_SUBMIT ||
                    event === loginEvent.FORGOT_PASSWORD
                  "
                >
                  ← Back to login
                </button>
                <button
                  class="w-50 btn btn-success text-uppercase"
                  *ngIf="event === loginEvent.FORGOT_PASSWORD"
                  (click)="forgetPassword()"
                >
                  Submit Username
                </button>
                <button
                  class="w-100 btn btn-success text-uppercase"
                  *ngIf="event === loginEvent.FORGOT_PASSWORD_SUBMIT"
                  (click)="forgetPasswordSubmit()"
                >
                  Submit forgot password
                </button>
                <button
                  class="w-50 btn btn-link"
                  (click)="changeToForgotPassword()"
                  *ngIf="event === loginEvent.LOGIN"
                >
                  Forgot password?
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
